import { create } from "zustand"

interface SettingsLanguageModalStore {
  isOpen: boolean
  onClose: () => void
  onOpen: () => void
}

const useSettingsLanguageModalStore = create<SettingsLanguageModalStore>(
  (set) => ({
    isOpen: false,
    onClose: () => set({ isOpen: false }),
    onOpen: () => set({ isOpen: true }),
  })
)

export default useSettingsLanguageModalStore
